import { IconCheckCircleOutline } from '@iwoca/icons';
import { Pill } from '@iwoca/orion';
import { Text } from '@iwoca/orion-ui';
import { NEW_IwLinkButton } from '@iwRouter/NEW_IwLinkButton';
import { FormattedMessage } from 'react-intl';

import { ONBOARDING_PATHS } from '../constants';

export const Onboarding = () => {
    return (
        <div className="m-auto mt-2xl flex flex-col gap-l text-center">
            <IconCheckCircleOutline className="m-auto text-5xl" />
            <Text className="text-center text-3xl font-bold">
                <FormattedMessage
                    id="_.credit_card.onboarding.title"
                    defaultMessage="You've been <span>approved</span> for £1,000 with an iwoca credit card."
                    values={{
                        span: (chunks) => (
                            <span className="text-success-drk">{chunks}</span>
                        )
                    }}
                />
            </Text>

            <Pill variant="london" size="small" className="m-auto w-1/2">
                <Text className="text-m font-med text-secondary-40">
                    <FormattedMessage
                        id="_.credit_card.onboarding.pilot_text"
                        defaultMessage="You're part of our pilot group"
                    />
                </Text>
            </Pill>

            {/* divider */}
            <div className="my-2xl border border-t-0 border-structure-80"></div>

            <Text className="text-center text-2xl font-bold">
                <FormattedMessage
                    id="_.credit_card.onboarding.activation.title"
                    defaultMessage="Let's get your card activated"
                />
            </Text>

            <Text className="text-center text-m">
                <FormattedMessage
                    id="_.credit_card.onboarding.activation.subtitle"
                    defaultMessage="You'll need to complete some onboarding steps in order to activate your card and start spending."
                />
            </Text>

            <NEW_IwLinkButton
                variant="primary"
                to={{ pathname: ONBOARDING_PATHS.ONBOARDING_CHECKS }}
                className="m-auto mt-s w-full min-m:w-1/2"
            >
                <Text className="font-med text-secondary-95">
                    <FormattedMessage
                        id="_.credit_card.offer.onboarding.cta"
                        defaultMessage="Continue to onboarding"
                    />
                </Text>
            </NEW_IwLinkButton>
        </div>
    );
};
